/**
 * @description: 用户管理
 * @author: 51fan
 */
<template>
  <div class="userManageContent main-wrap">
      <div class="main-top">
             <el-button type="primary" class="addAddress h40" @click="openDialog"  icon="iconfont iconxinzeng">{{$lang('新增用户')}}
            </el-button>
            <div class="searchParam">
            <div class="searchParamInput">
                <el-input v-model="searchParam.account" :placeholder="$lang('请输入登录账号')" style="width:336px !important"></el-input>
            </div>
            <el-button @click="searchChange" type="primary" icon="iconfont iconchaxun" class="h32 search">{{$lang('查询')}}</el-button>
            <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{$lang('清空')}}</el-button>
            </div>
      </div>

    <div class="main-table">
         <JmsTableScroll  ref="table" :option="listOpt" :data="tableList" :page="page" :table-loading="loading" @size-change="sizeChange"
        @select-change="selectionChange" @current-change="currentChange">
        <template slot="menu" slot-scope="scope">
            <el-button type="text" @click="edit(scope.row, 1)">{{$lang('重置密码')}}</el-button>
            <el-button type="text" @click="edit(scope.row, 2)">{{$lang('设置')}}</el-button>
            <el-button type="text" @click="rowDel(scope.row,scope.row.$index)">{{$lang('删除')}}</el-button>
            <el-button type="text" v-if="scope.row.isBindingGoogleTwoFactor" @click="resetGoogle(scope.row)">{{$lang('重置谷歌验证码')}}</el-button>
        </template>
        <template slot="status" slot-scope="data">
            <el-switch
                        disabled
                        v-model="data.row.status"
                        active-color="#13ce66"
                        inactive-color="#dcdfe6"
                        :active-value="1"
                        :inactive-value="2">
            </el-switch>
        </template>

        </JmsTableScroll>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="680px" @close="handleClose" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <div style="display:inline-flex;">
        <div v-show="isAdd">
          <el-form class="el-form-edit" ref="isAdd" :rules="rules" :inline="true" :model="addUserParams" label-position="left"
            label-suffix=" :">
            <el-col :span="8">
                 <el-form-item :label="$lang('登录账号')" prop="acconut">
              <el-input v-model="addUserParams.acconut" autocomplete="off" auto-complete="new-password" :placeholder="$lang('请输入登录账号')"></el-input>
            </el-form-item>
            </el-col>
           <el-col :span="8">
            <el-form-item :label="$lang('密码')" prop="passwordF">
              <el-input v-model="addUserParams.passwordF" :type="isShowPassword?'text':'password'" autocomplete="off" auto-complete="new-password" :placeholder="$lang('请输入密码')" ref="psdRef">
                  <i slot="suffix" class="iconfont" :class="{'iconxianshi':isShowPassword,'iconyincang':!isShowPassword}" @click="toggleIcon"></i>
              </el-input>
            </el-form-item>
             </el-col>
              <el-col :span="8">
            <el-form-item :label="$lang('确认密码')" prop="passwordAgain">
              <el-input v-model="addUserParams.passwordAgain" :type="isShowPassword2 ?'text':'password'"  autocomplete="off" auto-complete="new-password" :placeholder="$lang('请输入密码')">
                   <i slot="suffix" class="iconfont" :class="[ isShowPassword2 ? 'iconxianshi':'iconyincang']" @click="toggleIcon2"></i>
              </el-input>
            </el-form-item>
             </el-col>
                <el-col :span="8">
            <el-form-item :label="$lang('绑定手机号')" prop="contactMobile">
              <el-input v-model="addUserParams.contactMobile" autocomplete="off" auto-complete="new-password" :placeholder="$lang('请输入手机号')" maxlength="11">
              </el-input>
            </el-form-item>
                 </el-col>
            <el-col :span="4">
             <el-form-item :label="$lang('是否启用')">
                   <el-switch
                        v-model="addUserParams.status"
                        active-color="#13ce66"
                        inactive-color="#dcdfe6"
                        :active-value="1"
                        :inactive-value="2">
                    </el-switch>
            </el-form-item>
            </el-col>
            <el-col :span="4">
            <el-form-item :label="$lang('参考运费')">
                   <el-switch
                        v-model="addUserParams.freightStatus"
                        active-color="#13ce66"
                        inactive-color="#dcdfe6"
                        :active-value="1"
                        :inactive-value="0">
                    </el-switch>
            </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$lang('订单')">
                <div class="flex">
                  <el-switch
                    v-model="addUserParams.orderStatus"
                    active-color="#13ce66"
                    inactive-color="#dcdfe6"
                    :active-value="1"
                    :inactive-value="0">
                  </el-switch>
                  <el-checkbox-group v-show="addUserParams.orderStatus === 1" v-model="addUserParams.orderPermissions">
                    <el-checkbox label="orderReport">{{$lang('导出订单')}}</el-checkbox>
                    <el-checkbox label="orderEdit">{{$lang('修改订单')}}</el-checkbox>
                    <el-checkbox label="orderCancel">{{$lang('取消订单')}}</el-checkbox>
                    <el-checkbox label="orderPrint">{{$lang('打印面单')}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$lang('运单')">
                <div class="flex">
                    <el-switch
                      v-model="addUserParams.waybillStatus"
                      active-color="#13ce66"
                      inactive-color="#dcdfe6"
                      :active-value="1"
                      :inactive-value="0">
                  </el-switch>
                  <el-checkbox-group v-show="addUserParams.waybillStatus === 1" v-model="addUserParams.waybillPermissions">
                    <el-checkbox label="waybillReport">{{$lang('导出运单')}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
        <div v-show="!isAdd && isReset">
          <el-form class="el-form-edit" ref="isReset" :rules="rules" :inline="true" :model="addUserParams" label-position="left"
            label-suffix=" :">
            <el-form-item :label="$lang('密码')" prop="passwordF">
              <el-input v-model="addUserParams.passwordF" :type="isShowPassword3?'text':'password'" :placeholder="$lang('请输入密码')">
                    <i slot="suffix" class="iconfont" :class="[ isShowPassword3 ? 'iconxianshi':'iconyincang']" @click="toggleIcon3"></i>
              </el-input>
            </el-form-item>
            <el-form-item :label="$lang('确认密码')" prop="passwordAgain">
                <el-input v-model="addUserParams.passwordAgain" :type="isShowPassword4 ?'text':'password'"  autocomplete="off" auto-complete="new-password" :placeholder="$lang('请输入密码')">
                   <i slot="suffix" class="iconfont" :class="[ isShowPassword4 ? 'iconxianshi':'iconyincang']" @click="toggleIcon4"></i>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="!isAdd && !isReset">
          <div class="statusSetting">
            <span class="label">{{$lang('状态设置')}}:</span>
            <el-radio v-model="addUserParams.statusSetting" :label="1">{{$lang('启用')}}</el-radio>
            <el-radio v-model="addUserParams.statusSetting" :label="2">{{$lang('禁用')}}</el-radio>
          </div>
           <div class="statusSetting">
            <span class="label">{{$lang('参考运费')}}:</span>
            <el-radio v-model="addUserParams.freightStatus" :label="1">{{$lang('显示')}}</el-radio>
            <el-radio v-model="addUserParams.freightStatus" :label="0">{{$lang('隐藏')}}</el-radio>
          </div>
          <div style="width: 100%">
            <el-row>
              <el-col :span="24" class="statusSetting">
                  <span class="label">{{$lang('订单')}}:</span>
                  <div class="flex">
                    <el-switch
                      v-model="addUserParams.orderStatus"
                      active-color="#13ce66"
                      inactive-color="#dcdfe6"
                      :active-value="1"
                      :inactive-value="0">
                    </el-switch>
                    <el-checkbox-group v-show="addUserParams.orderStatus === 1" v-model="addUserParams.orderPermissions">
                      <el-checkbox label="orderReport">{{$lang('导出订单')}}</el-checkbox>
                      <el-checkbox label="orderEdit">{{$lang('修改订单')}}</el-checkbox>
                      <el-checkbox label="orderCancel">{{$lang('取消订单')}}</el-checkbox>
                      <el-checkbox label="orderPrint">{{$lang('打印面单')}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
              </el-col>
              <el-col :span="24" class="statusSetting">
                <span class="label">{{$lang('运单')}}:</span>
                  <div class="flex">
                      <el-switch
                        v-model="addUserParams.waybillStatus"
                        active-color="#13ce66"
                        inactive-color="#dcdfe6"
                        :active-value="1"
                        :inactive-value="0">
                    </el-switch>
                    <el-checkbox-group v-show="addUserParams.waybillStatus === 1" v-model="addUserParams.waybillPermissions">
                      <el-checkbox label="waybillReport">{{$lang('导出运单')}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="cancel">取 消</el-button> -->
        <div style="text-align:center;">
            <el-button type="primary" :loading="keyBtn" @click="addUserFun" class="h40 h104">{{$lang('确定')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import { reqUserList, addNewUser, UserDelete, UserUpdate } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'
import { RULES } from '@utils/rules'
import { subUserUnbindGoogle } from '@/api/base/public.js'
export default {
  name: 'UserManage',
  components: {
    JmsTableScroll
  },
  mixins: [mixin],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.addUserParams.passwordF) {
        callback(new Error(this.$lang('两次密码输入不一致!')))
      } else {
        callback()
      }
    }
    return {
      checkList: ['选中且禁用', '复选框 A'],
      COM_HTTP: {
        reqList: reqUserList,
        reqDel: UserDelete
      },
      dialogVisible: false,
      isAdd: true,
      isReset: true,
      dialogTitle: this.$lang('新增用户'),
      resetAccount: '',
      searchParam: {
        account: ''
      },
      flag: true,
      addUserParams: {
        statusSetting: '',
        freightStatus: 1, // 参考运费是否显示
        orderStatus: 0, // 订单权限
        orderPermissions: [], // 订单权限
        waybillStatus: 0, // 运单权限
        waybillPermissions: [], // 运单权限
        acconut: '',
        passwordF: '',
        passwordAgain: '',
        status: 1
      },
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      data: [
        {
          id: 1,
          label: this.$lang('我要寄件'),
          children: [
            {
              id: 7,
              label: this.$lang('单票下单')
            },
            {
              id: 8,
              label: this.$lang('批量下单')
            }
          ]
        },
        {
          id: 2,
          label: this.$lang('我的订单')
        },
        {
          id: 3,
          label: this.$lang('我的运单')
        },
        {
          id: 4,
          label: this.$lang('服务管理'),
          children: [
            {
              id: 9,
              label: this.$lang('用户管理')
            },
            {
              id: 10,
              label: this.$lang('快件跟踪')
            }
          ]
        },
        {
          id: 5,
          label: this.$lang('地址管理'),
          children: [
            {
              id: 11,
              label: this.$lang('寄件地址')
            },
            {
              id: 12,
              label: this.$lang('收件地址')
            }
          ]
        },
        {
          id: 6,
          label: this.$lang('用户管理')
        }
      ],
      isShowPassword: false,
      isShowPassword2: false,
      isShowPassword3: false,
      isShowPassword4: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableList: [],
      rules: {
        acconut: [RULES.required, RULES.tenNumStrChar],
        passwordF: [RULES.required, RULES.checkPassword],
        passwordAgain: [RULES.required, RULES.checkPassword, { validator: validatePass }],
        contactMobile: [RULES.required, RULES.phoneAndMobile]
      },
      delTitObj: {
        title: this.$lang('删除账号'),
        subTitle: this.$lang('你确定要删除已选中的账号吗？'),
        threeTitle: ''
      }
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 90,
        selection: false,
        rowKey: '$index',
        menu: this.flag,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 350,
        column: [
          {
            label: '登录账号', //  扫描员
            prop: 'account'
          },
          {
            label: '创建时间',
            prop: 'createTime'
          },
          {
            label: '绑定手机号',
            prop: 'contactMobile'
          },
          {
            label: '是否启用',
            prop: 'status',
            slot: true
            // formatter: (row, value, label, column) => {
            //   const map = {
            //     1: '<i class="dot green"></i> ' + '是',
            //     2: '<i class="dot yellow"></i> ' + '否',
            //   }
            //   return map[row.status]
            // },
          }
        ]
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    }
  },
  watch: {
    // 路由切换重新计算布局
    $route(to, form) {
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
    'addUserParams.orderStatus'(val) {
      val === 0 && (this.addUserParams.orderPermissions = [])
    },
    'addUserParams.waybillStatus'(val) {
      val === 0 && (this.addUserParams.waybillPermissions = [])
    }
  },
  methods: {
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword
    },
    toggleIcon2() {
      this.isShowPassword2 = !this.isShowPassword2
    },
    toggleIcon3() {
      this.isShowPassword3 = !this.isShowPassword3
    },
    toggleIcon4() {
      this.isShowPassword4 = !this.isShowPassword4
    },
    inputForce() {
      this.$refs.psdRef.$refs.input.type = 'password'
    },
    handleClose() {
      this.addUserParams = {
        statusSetting: '',
        freightStatus: 0,
        orderStatus: 0, // 订单权限
        orderPermissions: [], // 订单权限
        waybillStatus: 0, // 运单权限
        waybillPermissions: [], // 运单权限
        acconut: '',
        passwordF: '',
        passwordAgain: ''
      }
      this.dialogVisible = false
      this.$nextTick(function() {
        if (this.$refs['isAdd']) {
          this.$refs['isAdd'].resetFields()
        }
        if (this.$refs['isReset']) {
          this.$refs['isReset'].resetFields()
        }
      })
    },
    getParams() {
      return this.searchParam
    },
    openDialog() {
      this.isAdd = true
      this.dialogTitle = this.$lang('新增用户')
      console.log(this.addUserParams)
      this.resetParams()
      if (this.tableList.length > 30) {
        this.$message.error(this.$lang('每个主账号最多只能新增三十个子账号'))
      } else {
        this.dialogVisible = true
      }
    },
    edit(rows, index) {
      this.isAdd = false
      if (index === 1) {
        this.dialogTitle = this.$lang('重置密码')
        this.isReset = true
        this.resetAccount = rows.id
        this.addUserParams = {
          statusSetting: rows.status,
          acconut: '',
          passwordF: '',
          passwordAgain: ''
        }
      } else {
        this.dialogTitle = this.$lang('子账号设置')
        const menuId = rows.menuId ? rows.menuId.split(',') : []
        this.addUserParams.orderStatus = 0 // 订单权限
        this.addUserParams.waybillStatus = 0 // 订单权限
        this.addUserParams.orderPermissions = [] // 订单权限
        this.addUserParams.waybillPermissions = [] // 订单权限
        menuId.forEach(item => {
          if (item === 'waybillList') {
            this.addUserParams.waybillStatus = 1
          }
          if (item === 'orderList') {
            this.addUserParams.orderStatus = 1
          }
          if (['orderReport', 'orderPrint', 'orderCancel', 'orderEdit'].includes(item)) {
            this.addUserParams.orderPermissions.push(item)
          }
          if (['waybillReport'].includes(item)) {
            this.addUserParams.waybillPermissions.push(item)
          }
        })
        this.isReset = false
        this.resetAccount = rows.id
        this.addUserParams.statusSetting = rows.status === 1 ? 1 : 2
        this.addUserParams.freightStatus = rows.freightStatus === 1 ? 1 : 0
      }
      this.dialogVisible = true
    },
    resetGoogle(row) {
      this.$confirm(this.$lang('是否确认重置此账号谷歌验证码？'), this.$lang('温馨提示'), {
        confirmButtonText: this.$lang('确认'),
        cancelButtonText: this.$lang('取消'),
        type: 'warning'
      }).then(async () => {
        const { code, msg } = await subUserUnbindGoogle({ id: row.id })
        if (code === 1) {
          this.$message.success(this.$lang('重置成功'))
          this.searchChange()
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = ''
    },
    getfunParam(keyvalue) {
      let menuId = []
      Array.isArray(this.addUserParams.orderPermissions) && (menuId = menuId.concat(this.addUserParams.orderPermissions))
      Array.isArray(this.addUserParams.waybillPermissions) && (menuId = menuId.concat(this.addUserParams.waybillPermissions))
      console.log('🚀 ~ getfunParam ~ this.addUserParams:', this.addUserParams)

      if (this.addUserParams.orderStatus === 1) {
        menuId.push('orderList')
      }
      if (this.addUserParams.waybillStatus === 1) {
        menuId.push('waybillList')
      }
      if (keyvalue === 'isAdd') {
        const param = {
          account: this.addUserParams.acconut,
          pwd: this.$Base64.encode(this.addUserParams.passwordF + 'jadada236t2'),
          contactMobile: this.addUserParams.contactMobile,
          status: this.addUserParams.status,
          menuId: menuId.join(','),
          freightStatus: this.addUserParams.freightStatus
        }
        return param
      } else {
        if (this.isReset) {
          const param = {
            id: this.resetAccount,
            pwd: this.$Base64.encode(this.addUserParams.passwordF + 'jadada236t2'),
            status: this.addUserParams.statusSetting
          }
          return param
        } else {
          const param = {
            id: this.resetAccount,
            status: this.addUserParams.statusSetting,
            menuId: menuId.join(','),
            freightStatus: this.addUserParams.freightStatus
          }
          return param
        }
      }
    },
    async savefun(formName) {
      const param = this.getfunParam(formName)
      this.keyBtn = true
      const res = this.isAdd ? await addNewUser(param) : await UserUpdate(param)
      this.keyBtn = false
      if (res.code === RESPONSE_SUCCESS) {
        this.$message({
          message: this.isAdd ? this.$lang('新增成功') : this.$lang('修改成功'),
          type: 'success'
        })
        this.dialogVisible = false
        this.searchFun()
        this.cancel()
      } else {
        this.$message.error(res.msg)
      }
    },
    addUserFun() {
      console.log(this.addUserParams)
      const formName = this.isAdd ? 'isAdd' : 'isReset'
      if (this.isAdd || this.isReset) {
        console.log(11)
        this.$refs[formName].validate(valid => {
          if (valid) {
            // if (this.addUserParams.passwordF !== this.addUserParams.passwordAgain) {
            //   this.$message.error(this.$lang('两次密码不一致，请检查'))
            //   return
            // }
            this.savefun(formName)
          } else {
            return false
          }
        })
      } else {
        this.savefun()
      }
    },
    resetParams() {
      this.addUserParams = {
        statusSetting: '',
        freightStatus: '',
        orderStatus: 0, // 订单权限
        orderPermissions: [], // 订单权限
        waybillStatus: 0, // 运单权限
        waybillPermissions: [], // 运单权限
        acconut: '',
        passwordF: '',
        passwordAgain: '',
        status: 1
      }
    },
    cancel() {
      this.dialogVisible = false
      this.resetParams()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100% !important;
}
.flex {
  display: flex;
  align-items: center;
  height: 37px;
  ::v-deep .el-switch {
    margin-right: 30px;
  }
}
.el-table th.gutter {
  display: table-cell !important;
}
.userManageContent {
  .searchParam {
    // padding: 18px 0;
    margin-top: 10px;
    display: inline-flex;
    width: 100%;
    position: relative;
    .searchParamInput {
      padding-right: 16px;
    }
  }
  .main-top{
       padding:16px 24px;
  }
  .main-table{
    padding: 12px 24px;
    background: #edeef3;
    flex: 1
  }

  .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__body {
        padding: 0;
        .userTree {
          width: 200px;
          border-right: 1px dashed #eeeeee;
        }
        .myAccount {
          display: inline-flex;
          padding-top: 16px;
          .myAccountItem {
            width: 200px;
            padding: 0 8px;
            .myAccountItemText {
              padding-bottom: 4px;
            }
          }
        }
        .statusSetting {
        //   width: 200px;
          padding: 16px 8px;
          .statusSettingText {
            padding-bottom: 8px;
          }
          .label{
              margin-right:20px;
              font-size: 16px;
              font-weight: 600
          }
        }
        .require {
          color: red;
        }
      }
      .el-dialog__header {
        padding: 12px 25px !important;
        border-bottom: 1px solid #eeeeee;
      }
      .el-dialog__footer {
        // border-top: 1px solid #eeeeee;
        padding: 8px 24px 16px !important;
      }
    }
  }
  .dot {
    margin-right: 5px;
    width: 6px;
    height: 6px;
    background: #999;
    display: inline-flex;
    vertical-align: middle;
    border-radius: 50%;
    &.yellow {
      background: #ffa111;
    }
    &.green {
      background: #00da00;
    }
  }
  .iconfont{
      font-size: 14px;
  }
}

</style>

<style lang="scss">
.userManageContent{
    .iconfont{
        cursor: pointer;
    }
}
</style>
